import React from "react";
import Markdown from "../utility/markdown";
import RichButton from "../utility/rich-button";

const Text = ({component}) => {

    return (
        <div className={`m-auto md:w-3/4 mb-14 leading-none text-${component.contentAlignment}`}>
            <Markdown body={component.content.data.content}></Markdown>
            {component.buttons?.map((button) => (
                <RichButton key={button.id} button={button} />
            ))}
        </div>
    )
}

export default Text